import type { ReactNode } from "react";
import React from "react";
import { Col } from "react-bootstrap";

interface Props {
	title: string;
	icon: ReactNode;
}

export class LandingHowToItem extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { title, icon, children } = this.props;

		return (
			<Col xl={3} sm={6} className="how-to-item">
				<h3>
					<span className="text-secondary pr-2">{icon}</span>
					{title}
				</h3>
				<p className="mb-0">{children}</p>
			</Col>
		);
	}
}
